<template>
      <v-app id="inspire">
        <div class="container" >
            <v-flex xs12 sm6 offset-sm3>
            <v-card class="innerContainer">
                <v-card-title class="blue white--text">
                <span class="headline">Request Adjustment</span>
                <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text >
                <v-form onSubmit="return false;"  ref="form" lazy-validation>
                    <p>You can respond to us requesting a different amount or reply below with questions.</p>
                    <div class="col-md-12">
                        <vue-editor placeholder="Message to us" v-model="iso_message" :editorToolbar="customToolbar"></vue-editor>
                    </div>
                    <br>
                    <center>
                    <v-btn color="primary" @click="sendNotification" :disabled="progressModel">
                        Submit
                    </v-btn>
                    </center>
            
                </v-form>

                </v-card-text>
            </v-card>
            </v-flex>
        </div>
</v-app>
</template>
<script>
import {VueEditor} from 'vue2-editor';
import axios from 'axios';
import {URL, config} from '../../env'
export default {
    components: {
        VueEditor
    },
    data() {
        return {
            iso_message: null,
            accounting_reply: {},
            progressModel: false,
            customToolbar: [
				[{ header: [false, 1, 2, 3, 4, 5, 6] }],
				[{ size: ["small", "large", "huge"] }],
				["bold", "italic", "underline", "strike"],
				[
					{ align: "" },
					{ align: "center" },
					{ align: "right" },
					{ align: "justify" }
				],
				[{ header: 1 }, { header: 2 }],
				["blockquote", "code-block"],
				[{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
				[{ script: "sub" }, { script: "super" }],
				[{ indent: "-1" }, { indent: "+1" }],
				[{ color: [] }, { background: [] }],
				[{ direction: "rtl" }],
				["clean"]
			],
        }
    },
    mounted(){
        this.getData()
    },
    methods:{
        async getData(){
            await axios.get(URL+'/api/get_accounting_reply_data/'+this.$route.params.unique_id)
            .then(resp=>{
                this.accounting_reply = resp.data.length>0 ? resp.data[0] : {}
            })
        },
      async sendNotification(){

        let unique_id = this.$route.params.unique_id
        this.progressModel = true;
        await axios.post(URL+'/api/message_to_accounting', {message: this.iso_message, syndicate_id: this.accounting_reply.syndicate_id, deal_id: this.accounting_reply.deal_id, payPercent: this.accounting_reply.pay_percent, id: this.accounting_reply.id})
            .then(resp=>{
                this.progressModel = false;
                this.flash('Reply sent to accounting team', 'success', {
                    timeout: 3000
                });
                setTimeout(()=>{
                    window.close();
                },3000)
            })
        }
    }
}
</script>